// extracted by mini-css-extract-plugin
module.exports = {"root":"L_bJ"};